// GET_USER
export const GET_USER = "GET_USER";
export const USER_BLOCK = "USER_BLOCK";
//  get Plan Purchase users
export const GET_PLAN_PURCHASE_USERS = "GET_PLAN_PURCHASE_USERS";

//  get single user PROFILE
export const GET_SINGLE_USERS = "GET_SINGLE_USERS";

// get user history
export const GET_USER_CALL_HISTORY = "GET_USER_CALL_HISTORY";

export const GET_ALL_USER_HISTORY = "GET_ALL_USER_HISTORY";

// Update User Coin IN PROFILE
export const UPDATE_USER_COIN = "UPDATE_USER_COIN";
export const ACTIVE_SWITCH_USER = "ACTIVE_SWITCH_USER";
export const DELETE_USER = "DELETE_USER";
export const GET_USER_PROFILE = "GET_USER_PROFILE";
export const GET_COUNTRY = "GET_COUNTRY";
export const USER_EDIT_PROFILE = "USER_EDIT_PROFILE";
export const CREATE_FAKE_USER = "CREATE_FAKE_USER";
export const GET_IP_ADDRESS = "GET_IP_ADDRESS";
export const GET_FAKE_USER = "GET_FAKE_USER";
export const PAASWORD_CHANGE_API = "PAASWORD_CHANGE_API";

// Channel
export const GET_USER_CHANNEL_DATA = "GET_USER_CHANNEL_DATA";
export const CREATE_FAKE_USER_CHANNEL = "CREATE_FAKE_USER_CHANNEL";
export const GET_FAKE_USER_NAME = "GET_FAKE_USER_NAME";
export const GET_FAKE_USER_CHANNEL_DATA = "GET_FAKE_USER_CHANNEL_DATA";
